import React from "react";
import "./ClosingThoughtsSection.scss";
import ContentSection from "../components/ContentSection";
import SectionHeader from "../components/SectionHeader";
import TwoColumnLayout from "../components/TwoColumnLayout";

const ClosingThoughtsSection: React.FC = () => {
  const leftContent = (
    <div className="closing-thoughts-section-content">
      <p>
        The preceding was informed from how the field has responded during this
        and previous periods of uncertainty. Looking forward, we must draw on
        that history of resilience to ensure our communities, and the
        justice-involved workforce within them, continue to receive the services
        and support they need.
      </p>
      <p>
        We are grateful to all who contributed their perspectives to this
        report. To those who completed the survey, participated in interviews,
        and submitted personal stories, your experiences provided essential
        insight and helped shape the findings presented here.
      </p>
    </div>
  );

  const rightContent = <></>;

  return (
    <ContentSection className="closing-thoughts-section">
      <SectionHeader
        title="Recommendations and Conclusion"
        description="Closing Thoughts and Acknowledgments"
      />
      <TwoColumnLayout leftContent={leftContent} rightContent={rightContent} />

      <h3 className="grid-heading sr-only">Contributors</h3>
      <div className="contributors-grid">
        <div className="contributor-item">
          <strong>Harry Alston</strong>
          <p>Safer Foundation</p>
        </div>
        <div className="contributor-item">
          <strong>Scott Dane</strong>
          <p>Nation Outside</p>
        </div>
        <div className="contributor-item">
          <strong>Cynthia Nwaranche</strong>
          <p>
            Virginia Department of
            <br />
            Criminal Justice Services
          </p>
        </div>
        <div className="contributor-item">
          <strong>Cory Miskell</strong>
          <p>
            Latino Coalition for
            <br />
            Community Leadership
          </p>
        </div>
        <div className="contributor-item">
          <strong>Christopher Watler</strong>
          <p>
            Center for Employment
            <br />
            Opportunities
          </p>
        </div>
        <div className="contributor-item">
          <strong>Christina Yancey</strong>
          <p>
            American Institutes for
            <br />
            Research
          </p>
        </div>
        <div className="contributor-item">
          <strong>Trevor White</strong>
          <p>
            Tennessee Department of
            <br />
            Labor and Workforce
            <br />
            Development
          </p>
        </div>
        <div className="contributor-item">
          <strong>Ty Reed</strong>
          <p>
            Washington State
            <br />
            Employment Security
            <br />
            Department
          </p>
        </div>
        <div className="contributor-item">
          <strong>William Arnold</strong>
          <p>
            Tennessee Department of
            <br />
            Labor and Workforce
            <br />
            Development
          </p>
        </div>
        <div className="contributor-item">
          <strong>Hannah Smith</strong>
          <p>Exygy</p>
        </div>
      </div>

      <div className="closing-thoughts-credits">
        This report was made possible by the expertise of{" "}
        <a href="https://exygy.com" target="_blank" rel="noopener noreferrer">
          Exygy Inc.
        </a>{" "}
        who led the data analysis, design, and compilation of this report.
      </div>
    </ContentSection>
  );
};

export default ClosingThoughtsSection;
